export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl p-6 md:p-10 lg:p-12 border border-background-200/70">
          <div className="flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-gradient-to-br from-primary-400 to-accent-400 flex items-center justify-center">
              <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50"></i>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              海角移动端入口
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg lg:max-w-none">
              随时随地访问海角网，移动端适配完美，让你在手机和平板上也能畅享海角视频、社区讨论和论坛互动的完整体验。
              海角网址移动版同步更新，保持与桌面端一致的内容生态。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-5">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill"></i>
                iOS 版
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill"></i>
                Android 版
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-100 text-foreground-700 text-sm font-medium rounded-full border border-background-300/60 hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-global-line"></i>
                网页版直达
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}